import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'xp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(private route: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        const pathName: string = window.location.pathname;
        const regex = /^\/(?<type>conflictcheck|idverification)\/(?<matterNo>\d+)\/(?<jurisdictionCode>[^/]+)$/;

        const match = pathName.match(regex);
        if (match !== null && match.groups) {
            sessionStorage.setItem("type", match.groups["type"]);
            sessionStorage.setItem("matterId", match.groups["matterNo"]);
            sessionStorage.setItem("actionStepOrgKey", match.groups["jurisdictionCode"]);
        }
    }
}
